import React, { useCallback } from 'react';
import { Box, Hint, HintText, Text } from '@common-fe/common-fe';

import Link from '@/modules/core/components/Link';

import { StatisticCard, StatisticDetailsIcon } from '../../StatisticCard.styles';
import { CIPStatisticTileConfig } from '../CIPStatistic.types';

import CIPStatisticModal from './CIPStatisticModal';
import CIPStatisticTile from './CIPStatisticTile';

export interface CIPStatisticProps {
  isLoading?: boolean;
  url: string;
  tiles: CIPStatisticTileConfig[];
  closureDelayDays?: number;
  isDetailsLinkVisible?: boolean;
}
export const CIPStatistic: React.FC<CIPStatisticProps> = ({
  isLoading,
  tiles,
  url,
  closureDelayDays,
  isDetailsLinkVisible,
}) => {
  const getWrapper = useCallback(
    (node: React.ReactNode) => {
      if (isDetailsLinkVisible) {
        return (
          <Link testId="dashboard_statistics_cip-statistic_details-link" isOpenNewTab to={url}>
            {node}
          </Link>
        );
      }
      return node;
    },
    [isDetailsLinkVisible, url]
  );

  return getWrapper(
    <StatisticCard
      data-testid="dashboard_statistics_cip-statistic"
      background="canvas"
      border={{ color: 'border2', size: '1px' }}
      round="container1Round"
      pad="spacing16"
      direction="column"
      gap="spacing12"
      height={{ min: 'fit-content' }}
    >
      <Box direction="row" align="center" justify="between" gap="spacing12" height="20px">
        <Box direction="row" align="center" gap="spacing8">
          <Hint
            hintWidth={240}
            hintHeight={100}
            hintElement={
              <Box>
                <HintText>
                  <Text data-testid="dashboard_statistics_cip-statistic_title" size="medium" weight={700}>
                    Customer Identification Program
                  </Text>
                </HintText>
              </Box>
            }
          >
            <Text data-testid="dashboard_statistics_cip-statistic_title_hint" textAlign="center" size="small">
              To establish each employee’s HSA, we’re required to verify their identity
            </Text>
          </Hint>

          <CIPStatisticModal closureDelayDays={closureDelayDays} />
        </Box>

        {isDetailsLinkVisible && (
          <Box justify="center" align="center" width="24px" height="24px">
            <StatisticDetailsIcon
              data-testid="dashboard_statistics_cip-statistic_details-icon"
              color="iconDisabled"
            />
          </Box>
        )}
      </Box>

      <Box direction="row" align="stretch" gap="spacing8">
        {tiles.map((tile) => (
          <CIPStatisticTile key={tile.type} {...tile} isLoading={isLoading} />
        ))}
      </Box>
    </StatisticCard>
  );
};

export default CIPStatistic;
